/*
 * Sends customers back to the page they were on after logging in or registering,
 * instead of the account page.
 *
 * - On every page, login/register links get `?return_url=<current page>` added
 *   when clicked (covers links rendered later, e.g. in the cart drawer or modal).
 * - On the login/register pages, that value is passed to Shopify's
 *   customer_login / create_customer forms as a hidden `return_to` input.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'login-return-url';

  function isSafePath(value) {
    return typeof value === 'string' && value.charAt(0) === '/' && value.charAt(1) !== '/' && value.charAt(1) !== '\\';
  }

  function pathOf(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (e) {
      return '';
    }
  }

  var authPaths = [window.loginUrl, window.registerUrl]
    .filter(Boolean)
    .map(pathOf)
    .filter(function (path) {
      return path && path.charAt(0) === '/';
    });

  function isAuthPage() {
    return /\/account(\/|$)/.test(window.location.pathname);
  }

  function addReturnUrl(link) {
    if (isAuthPage()) return;
    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (authPaths.indexOf(url.pathname.replace(/\/$/, '')) === -1) return;
    url.searchParams.set('return_url', window.location.pathname + window.location.search);
    link.href = url.pathname + url.search + url.hash;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (link) addReturnUrl(link);
    },
    true
  );

  function getReturnUrl() {
    var fromQuery = new URLSearchParams(window.location.search).get('return_url');
    try {
      if (isSafePath(fromQuery)) {
        sessionStorage.setItem(STORAGE_KEY, fromQuery);
        return fromQuery;
      }
      // Keep the value when the form re-renders after a failed attempt (no query string then).
      var stored = sessionStorage.getItem(STORAGE_KEY);
      return isSafePath(stored) ? stored : null;
    } catch (e) {
      return isSafePath(fromQuery) ? fromQuery : null;
    }
  }

  function initAuthForms() {
    var forms = document.querySelectorAll(
      'form[action*="/account/login"], form[action$="/account"], form#customer_login, form#create_customer'
    );
    if (!forms.length) return;

    var returnUrl = getReturnUrl();
    if (!returnUrl) return;

    forms.forEach(function (form) {
      // Leave the password recovery form alone.
      if (form.querySelector('input[name="form_type"][value="recover_customer_password"]')) return;
      var input = form.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
      }
      input.value = returnUrl;
    });
  }

  if (!isAuthPage()) {
    // The stored value only needs to survive a failed login on the login page.
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  } else {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAuthForms);
    } else {
      initAuthForms();
    }
  }
})();
